import React, { createContext, useContext } from 'react'

import { Theme } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import { Context } from './TableFrame-component'
import { useTranslation } from 'react-i18next'

export interface StyleProps {
    gridAutoRows: string
}

const useStyles = makeStyles<Theme, StyleProps>(theme => ({
    splitTableCellView: {
        display: 'grid',
        gridTemplateColumns: 'repeat(2, 1fr)',
        gridAutoRows: ({ gridAutoRows }) => gridAutoRows,
        marginTop: '20px',
        gridGap: '0 25px',
        [theme.breakpoints.down('md')]: {
            display: 'block',
        },
    },
}))

interface IProps {
    data: any
    height: string
}

export const TableSplitView: React.FC<IProps> = ({ data, height }) => {
    const { t } = useTranslation()

    const props: StyleProps = {
        gridAutoRows: `minmax(${height}px, auto)`,
    }

    const { classes } = useContext(Context)
    const localStyles = useStyles(props)

    return (
        <div className={localStyles.splitTableCellView}>
            {!!data?.some(Boolean) &&
                data?.map(
                    ({ name, value }, i) =>
                        !!name &&
                        !!value && (
                            <div key={`${value} + ${name}`} className={classes.splitTableCell}>
                                <div className={classes.splitTableCellName}>{t(name)}</div>
                                <div className={classes.splitTableCellValue}>{t(value)}</div>
                            </div>
                        )
                )}
        </div>
    )
}
